// extracted by mini-css-extract-plugin
export default {"renderer":"Renderer_renderer__zwhTi"};